import React, { type FC } from 'react'

import Dialog from '@mui/material/Dialog'
import Button from '@mui/material/Button'

import { DeviceForProvisionFields } from './DeviceForProvisionFields'

import {
  createDeviceForProvision,
  NewDeviceForProvisionValuesChangedAction,
  SetCreateDeviceDialogStateAction
} from '../../../redux/admin/admin-device-provisions-actions'
import { DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { type DeviceForProvisionWithoutId } from '../../../redux/admin/admin-device-provisions-types'
import { type RootState } from '../../../redux/store'

export const CreateDeviceForProvisionDialog: FC = () => {
  const dispatch = useAppDispatch()
  const newDeviceForProvision = useAppSelector((state: RootState) => state.adminDeviceProvisions.newDeviceForProvision)

  const createDeviceForProvisionDialogOpen =
        useAppSelector<boolean>((state: RootState) => state.adminDeviceProvisions.createDeviceForProvisionDialogOpen)

  const selectedTenant = useAppSelector<string>((state: RootState) => state.adminDeviceProvisions.selectedTenant)

  const closeDialog = (): void => {
    dispatch(SetCreateDeviceDialogStateAction({ isOpen: false }))
  }

  const disabled = (): boolean => {
    return (newDeviceForProvision.serialNumber === '') ||
            newDeviceForProvision.devEUI === '' ||
            newDeviceForProvision.appEUI === '' ||
            newDeviceForProvision.appKey === '' ||
            newDeviceForProvision.deviceProfileId === ''
  }

  const onCreateDeviceForProvision = (): void => {
    dispatch(createDeviceForProvision({
      devEUI: newDeviceForProvision.devEUI,
      serialNumber: newDeviceForProvision.serialNumber,
      appEUI: newDeviceForProvision.appEUI,
      appKey: newDeviceForProvision.appKey,
      deviceProfileId: newDeviceForProvision.deviceProfileId,
      tenantName: selectedTenant
    })).catch(err => {
      console.error('create device for provision error: ', err)
    })
  }

  const valueChanged = (field: keyof DeviceForProvisionWithoutId, value: string): void => {
    const payload: DeviceForProvisionWithoutId = { ...newDeviceForProvision, [field]: value }
    dispatch(NewDeviceForProvisionValuesChangedAction(payload))
  }

  return (
        <Dialog
            open={createDeviceForProvisionDialogOpen}
        >
            <DialogTitle>Lisää aktivoitava mittari</DialogTitle>
            <DialogContent>
                <DeviceForProvisionFields
                    deviceForProvision={newDeviceForProvision}
                    valueChanged={valueChanged}
                />
            </DialogContent>
            <DialogActions>
                <Button key="cancel" color="primary" onClick={() => {
                  closeDialog()
                }}>Peruuta</Button>,
                <Button
                    key="add"
                    disabled={disabled()}
                    onClick={() => {
                      onCreateDeviceForProvision()
                    }}
                    color="secondary"
                >Lisää
                </Button>
            </DialogActions>
        </Dialog>
  )
}
